import React from 'react'
import TopNav from '../../Layouts/TopNav'
import BottomFooter from '../../Layouts/BottomFooter'
// import Footer from '../../Layouts/Footer'
// import MainPage from '../../components/Home/MainPage'
import Main from '../../components/Homepage/Main'

const Home = (props) => {
    return (

        <div className="Homepage">
            <TopNav />
            <Main />
            <BottomFooter />
        </div>

    )
}

export default Home;